import axios from "axios";

// A plain <a href> can't carry the Authorization header these export
// endpoints require, so the file is fetched as a blob and "downloaded"
// via a throwaway object URL instead - same result, just needs the extra
// step. Reads the filename the server chose (Content-Disposition) rather
// than hardcoding one here, so the two stay in sync automatically.
export async function downloadExport(url, token, fallbackFilename) {
  const response = await axios.get(url, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });

  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename="([^"]+)"/);
  const filename = match ? match[1] : fallbackFilename;

  const blobUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
}
